import { Component, Input, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Modal } from 'bootstrap';
import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-leads-show-tags',
	templateUrl: './leads-show-tags.component.html',
	styleUrls: ['./leads-show-tags.component.css'],
})
export class LeadsShowTagsComponent implements OnInit {
	tagsHint: Array<string> = [];
	newTag: string = null;
	private removeTag: string = null;
	@Input() leadId: number;
	@Input() tags: Array<any>;
	@Output() changed = new EventEmitter();

	constructor(private readonly api: Data2Service) {}

	ngOnInit(): void {
		this.api.get('/definitions/tagsLeads/', (result, error) => {
			result.data.forEach((obj) => {
				obj.name = obj.groupName + ' / ' + obj.tag;
			});
			this.tagsHint = result.data;
		});
	}

	submit(): void {
		if (!this.newTag) {
			return;
		}
		this.api.post('/leads/' + this.leadId + '/tagAdd/', { tag: this.newTag }, (result, error) => {
			if (error) {
				alert('error - check console');
				return;
			}
			this.newTag = '';
			this.changed.emit();
		});
	}

	removeAsk(item): void {
		this.removeTag = item;
		new Modal(document.getElementById('askTagsModal')).show();
	}

	askNo() {
		const modal = Modal.getInstance(document.getElementById('askTagsModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	askYes(): void {
		this.askNo();
		if (!this.removeTag) {
			return;
		}
		this.api.post('/leads/' + this.leadId + '/tagDel/', { tag: this.removeTag }, (result, error) => {
			if (error) {
				alert('error - check console');
				return;
			}
			this.changed.emit();
		});
	}
}
